module.exports = __webpack_public_path__ + "media/assets/stores/kobo-e5808bbf68c04fe53e157ea1609b4969.jpg";